import helpLogo from "../assets/images/help.jpg";

import { FiMail, FiPhone, FiMapPin } from "react-icons/fi";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

export default function HelpSection() {
  return (
    <section className="text-white py-16 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <img
            src={helpLogo}
            alt="Help"
            className="w-28 h-28 rounded-full mx-auto mb-6 object-cover border-4 border-white/10 shadow-lg"
          />

          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Need Help?
          </h1>

          <p className="max-w-2xl mx-auto text-slate-300 text-lg">
            For any enquiries, technical support, or assistance using
            Kanema Online, get in touch through any of the channels below.
          </p>
        </div>

        {/* Cards */}
        <div className="grid gap-8 md:grid-cols-3">
          {/* Contact */}
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-3xl p-8 hover:-translate-y-1 transition-all duration-300">
            <div className="flex justify-center mb-5">
              <div className="bg-blue-500/20 p-4 rounded-full">
                <FiPhone className="text-3xl text-blue-400" />
              </div>
            </div>

            <h2 className="text-2xl font-semibold text-center mb-6">
              Contact Us
            </h2>

            <div className="space-y-4 text-slate-300">
              <div className="flex items-center justify-center gap-2">
                <FiMail />
                <span>info@kanemaonline.com</span>
              </div>

              <div className="flex items-center justify-center gap-2">
                <FiPhone />
                <span>+265 999 886 349</span>
              </div>

              <div className="flex items-center justify-center gap-2">
                <FiPhone />
                <span>+265 888 886 349</span>
              </div>
            </div>
          </div>

          {/* Address */}
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-3xl p-8 hover:-translate-y-1 transition-all duration-300">
            <div className="flex justify-center mb-5">
              <div className="bg-green-500/20 p-4 rounded-full">
                <FiMapPin className="text-3xl text-green-400" />
              </div>
            </div>

            <h2 className="text-2xl font-semibold text-center mb-6">
              Postal Address
            </h2>

            <div className="text-center text-slate-300 space-y-2">
              {/* <p>Kanema Online</p> */}
              <p>Static Computers Limited</p>
              <p>P.O. Box 400</p>
              <p>Lilongwe, Malawi</p>
            </div>
          </div>

          {/* Social Media */}
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-3xl p-8 hover:-translate-y-1 transition-all duration-300">
            <h2 className="text-2xl font-semibold text-center mb-6">
              Follow Us
            </h2>

            <div className="flex justify-center gap-4">
              <a
                href="https://www.facebook.com/kanemaonline1"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center rounded-full bg-white text-black hover:scale-110 transition-transform"
              >
                <FaFacebookF />
              </a>

              <a
                href="https://www.instagram.com/kanemaonline"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center rounded-full bg-white text-black hover:scale-110 transition-transform"
              >
                <FaInstagram />
              </a>

              <a
                href="https://www.twitter.com/KanemaOnline"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center rounded-full bg-white text-black hover:scale-110 transition-transform"
              >
                <FaXTwitter />
              </a>
              <a
                href="https://www.youtube.com/@kanemaonline"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 rounded-full bg-white text-slate-900 flex items-center justify-center hover:scale-110 transition"
              >
                <FaYoutube />
              </a>
            </div>

            <p className="text-center text-slate-400 mt-6">
              Stay connected with us on social media.
            </p>
          </div>
        </div>

        {/* CTA */}
        {/* <div className="mt-14 text-center">
          <a
            href="mailto:info@kanemaonline.com"
            className="inline-flex items-center gap-2 bg-white text-slate-900 px-6 py-3 rounded-full font-semibold hover:scale-105 transition-transform"
          >
            <FiMail />
            Contact Support
          </a>
        </div> */}
      </div>
    </section>
  );
}